<template lang="pug">
.m-card
  .m-card-header-wrapper(
    v-if="source.items != null && source.items[0] != null && source.items.length == 16"
    :data-bs-toggle="source.items[0].marketId != 3 ? 'collapse' : null"
    :href="source.items[0].marketId != 3 ? '#collapse-match-' + index + source.items[0].marketId : null"
    role='button'
    :aria-expanded="source.items[0].marketId == 3 ? 'true' : 'false'"
    :aria-controls="'collapse-match-' + index + source.items[0].marketId"
  )
    //- small {{ source.items[0].leagueName }}
    efTimer(:source="source.items[0]")
  .m-card-body.collapse.show(
    v-if="source.items[0].marketId != 3"
    :id="'collapse-match-' + index + source.items[0].marketId"
  )
    .m-card-item
      .m-card-wrap
        .section.winners-market
          .m-label-top
            img(src='images/vgame/crown/no1.svg')
            |  {{ $t("ui.no1") }}
          .odds-group
            .col
              template(v-if="source.items[15] && source.items[15].details['ou'] && source.items[15].details['ou'][0] && source.items[15].details['ou'][0][11] != 0 && source.items[15].details['ou'][0][12] != 0 && source.items[15].details['ou'][0][11] != '' && source.items[15].details['ou'][0][12] != ''")
                OddsItem(:odds="source.items[15].details['ou'][0]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" count=0 :details="source.items[15].details" homeAway="1")
              template(v-else)
                OddsDisabled
            .col
              template(v-if="source.items[15] && source.items[15].details['ou'] && source.items[15].details['ou'][0] && source.items[15].details['ou'][0][11] != 0 && source.items[15].details['ou'][0][12] != 0 && source.items[15].details['ou'][0][11] != '' && source.items[15].details['ou'][0][12] != ''")
                OddsItem(:odds="source.items[15].details['ou'][0]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" count=0 :details="source.items[15].details" homeAway="2")
              template(v-else)
                OddsDisabled
            .col
              template(v-if="source.items[15] && source.items[15].details['oe'] && source.items[15].details['oe'][0] && source.items[15].details['oe'][0][5] != 0 && source.items[15].details['oe'][0][5] != ''")
                OddsItem(:odds="source.items[15].details['oe'][0]" idx=5 :typ="oddsType" dataType="2" label="odd")
              template(v-else)
                OddsDisabled
            .col
              template(v-if="source.items[15] && source.items[15].details['oe'] && source.items[15].details['oe'][0] && source.items[15].details['oe'][0][7] != 0 && source.items[15].details['oe'][0][7] != ''")
                OddsItem(:odds="source.items[15].details['oe'][0]" idx=7 :typ="oddsType" dataType="2" label="even")
              template(v-else)
                OddsDisabled
        .section.normal-market
          .odds-group
            .col
              .odd-box-wrapper
                .m-label-betype {{ team(source.items[12], 0, true) }}
                template(v-if="source.items[12].details['oxt'] && source.items[12].details['oxt'][0] && source.items[12].details['oxt'][0][5] != 0 && source.items[12].details['oxt'][0][5] != ''")
                  OddsItem(:odds="source.items[12].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2" label="marbleItem")
                template(v-else)
                  OddsDisabled
              .odd-box-wrapper
                .m-label-betype
                  img.icon(:src="getImage(source.items[0])")
                  |  {{ team(source.items[0], 1) }}
                template(v-if="source.items[0].details['oxt'] && source.items[0].details['oxt'][0] && source.items[0].details['oxt'][0][5] != 0 && source.items[0].details['oxt'][0][5] != ''")
                  OddsItem(:odds="source.items[0].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2" label="marbleItem")
                template(v-else)
                  OddsDisabled
              .odd-box-wrapper
                .m-label-betype
                  img.icon(:src="getImage(source.items[3])")
                  |  {{ team(source.items[3], 1) }}
                template(v-if="source.items[3].details['oxt'] && source.items[3].details['oxt'][0] && source.items[3].details['oxt'][0][5] != 0 && source.items[3].details['oxt'][0][5] != ''")
                  OddsItem(:odds="source.items[3].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2" label="marbleItem")
                template(v-else)
                  OddsDisabled
              .odd-box-wrapper
                .m-label-betype
                  img.icon(:src="getImage(source.items[6])")
                  |  {{ team(source.items[6], 1) }}
                template(v-if="source.items[6].details['oxt'] && source.items[6].details['oxt'][0] && source.items[6].details['oxt'][0][5] != 0 && source.items[6].details['oxt'][0][5] != ''")
                  OddsItem(:odds="source.items[6].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2" label="marbleItem")
                template(v-else)
                  OddsDisabled
              .odd-box-wrapper
                .m-label-betype
                  img.icon(:src="getImage(source.items[9])")
                  |  {{ team(source.items[9], 1) }}
                template(v-if="source.items[9].details['oxt'] && source.items[9].details['oxt'][0] && source.items[9].details['oxt'][0][5] != 0 && source.items[9].details['oxt'][0][5] != ''")
                  OddsItem(:odds="source.items[9].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2" label="marbleItem")
                template(v-else)
                  OddsDisabled
            .col
              .odd-box-wrapper
                .m-label-betype {{ team(source.items[13], 0, true) }}
                template(v-if="source.items[13].details['oxt'] && source.items[13].details['oxt'][0] && source.items[13].details['oxt'][0][5] != 0 && source.items[13].details['oxt'][0][5] != ''")
                  OddsItem(:odds="source.items[13].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2" label="marbleItem")
                template(v-else)
                  OddsDisabled
              .odd-box-wrapper
                .m-label-betype
                  img.icon(:src="getImage(source.items[1])")
                  |  {{ team(source.items[1], 1) }}
                template(v-if="source.items[1].details['oxt'] && source.items[1].details['oxt'][0] && source.items[1].details['oxt'][0][5] != 0 && source.items[1].details['oxt'][0][5] != ''")
                  OddsItem(:odds="source.items[1].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2" label="marbleItem")
                template(v-else)
                  OddsDisabled
              .odd-box-wrapper
                .m-label-betype
                  img.icon(:src="getImage(source.items[4])")
                  |  {{ team(source.items[4], 1) }}
                template(v-if="source.items[4].details['oxt'] && source.items[4].details['oxt'][0] && source.items[4].details['oxt'][0][5] != 0 && source.items[4].details['oxt'][0][5] != ''")
                  OddsItem(:odds="source.items[4].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2" label="marbleItem")
                template(v-else)
                  OddsDisabled
              .odd-box-wrapper
                .m-label-betype
                  img.icon(:src="getImage(source.items[7])")
                  |  {{ team(source.items[7], 1) }}
                template(v-if="source.items[7].details['oxt'] && source.items[7].details['oxt'][0] && source.items[7].details['oxt'][0][5] != 0 && source.items[7].details['oxt'][0][5] != ''")
                  OddsItem(:odds="source.items[7].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2" label="marbleItem")
                template(v-else)
                  OddsDisabled
              .odd-box-wrapper
                .m-label-betype
                  img.icon(:src="getImage(source.items[10])")
                  |  {{ team(source.items[10], 1) }}
                template(v-if="source.items[10].details['oxt'] && source.items[10].details['oxt'][0] && source.items[10].details['oxt'][0][5] != 0 && source.items[10].details['oxt'][0][5] != ''")
                  OddsItem(:odds="source.items[10].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2" label="marbleItem")
                template(v-else)
                  OddsDisabled
            .col
              .odd-box-wrapper
                .m-label-betype {{ team(source.items[14], 0, true) }}
                template(v-if="source.items[14].details['oxt'] && source.items[14].details['oxt'][0] && source.items[14].details['oxt'][0][5] != 0 && source.items[14].details['oxt'][0][5] != ''")
                  OddsItem(:odds="source.items[14].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2" label="marbleItem")
                template(v-else)
                  OddsDisabled
              .odd-box-wrapper
                .m-label-betype
                  img.icon(:src="getImage(source.items[2])")
                  |  {{ team(source.items[2], 1) }}
                template(v-if="source.items[2].details['oxt'] && source.items[2].details['oxt'][0] && source.items[2].details['oxt'][0][5] != 0 && source.items[2].details['oxt'][0][5] != ''")
                  OddsItem(:odds="source.items[2].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2" label="marbleItem")
                template(v-else)
                  OddsDisabled
              .odd-box-wrapper
                .m-label-betype
                  img.icon(:src="getImage(source.items[5])")
                  |  {{ team(source.items[5], 1) }}
                template(v-if="source.items[5].details['oxt'] && source.items[5].details['oxt'][0] && source.items[5].details['oxt'][0][5] != 0 && source.items[5].details['oxt'][0][5] != ''")
                  OddsItem(:odds="source.items[5].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2" label="marbleItem")
                template(v-else)
                  OddsDisabled
              .odd-box-wrapper
                .m-label-betype
                  img.icon(:src="getImage(source.items[8])")
                  |  {{ team(source.items[8], 1) }}
                template(v-if="source.items[8].details['oxt'] && source.items[8].details['oxt'][0] && source.items[8].details['oxt'][0][5] != 0 && source.items[8].details['oxt'][0][5] != ''")
                  OddsItem(:odds="source.items[8].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2" label="marbleItem")
                template(v-else)
                  OddsDisabled
              .odd-box-wrapper
                .m-label-betype
                  img.icon(:src="getImage(source.items[11])")
                  |  {{ team(source.items[11], 1) }}
                template(v-if="source.items[11].details['oxt'] && source.items[11].details['oxt'][0] && source.items[11].details['oxt'][0][5] != 0 && source.items[11].details['oxt'][0][5] != ''")
                  OddsItem(:odds="source.items[11].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2" label="marbleItem")
                template(v-else)
                  OddsDisabled

//- .eracing-mainmarket-group.marble-survival-group
//-   .eracing-mainmarket-item.collapsed(
//-     v-if="source.items != null && source.items[0] != null && source.items.length == 16"
//-     type='button' 
//-     :id="source.items[0].id"
//-     data-toggle='collapse' 
//-     :data-target="'#mainmarket-' + source.items[0].matchId"
//-   )
//-     //- .row.m-0.align-items-center
//-     efTimer(:source="source.items[0]" :class="{ 'd-none' : source.items[0].marketId == 3 }")
//-       //- .mr-2.time-remaining.red-text
//-       //-   i.far.fa-stopwatch
//-       //-   span 58s
//-     .live-icon-wrapper(:class="{ 'd-none' : source.items[0].marketId != 3 }")
//-       img.live-icon(src='images/egame/live-icon.svg')
//-       span.mx-1 LIVE
//-       .live-dot
//-   .collapse.show(
//-     :id="'mainmarket-' + source.items[0].matchId"
//-   )
//-     .match-collapse-body
//-       //- small {{ source.items[12].homeTeam }}
//-       .winners-market.mb-1
//-         .player-wrapper
//-           .d-flex.align-items-center.justify-content-center.mt-2.mb-2.player-info-wrapper
//-             img.characters(src='images/egame/crown/no1.svg')
//-             .ml-2.player-name-wrapper
//-               | {{ $t("ui.no1") }}
//-           .d-flex.align-items-center.mb-1
//-             template(v-if="source.items[0].marketId == 3")
//-               .eracing-odds.flex-grow-1
//-                 OddsDisabled
//-               .eracing-odds.flex-grow-1
//-                 OddsDisabled
//-               .eracing-odds.flex-grow-1
//-                 OddsDisabled
//-               .eracing-odds.flex-grow-1
//-                 OddsDisabled
//-             template(v-else)
//-               .eracing-odds.flex-grow-1
//-                 template(v-if="source.items[15] && source.items[15].details['ou'] && source.items[15].details['ou'][0] && source.items[15].details['ou'][0][11] != 0 && source.items[15].details['ou'][0][12] != 0 && source.items[15].details['ou'][0][11] != '' && source.items[15].details['ou'][0][12] != ''")
//-                   OddsItem(:odds="source.items[15].details['ou'][0]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" count=0 :details="source.items[15].details" homeAway="1")
//-                 template(v-else)
//-                   OddsDisabled
//-               .eracing-odds.flex-grow-1
//-                 template(v-if="source.items[15] && source.items[15].details['ou'] && source.items[15].details['ou'][0] && source.items[15].details['ou'][0][11] != 0 && source.items[15].details['ou'][0][12] != 0 && source.items[15].details['ou'][0][11] != '' && source.items[15].details['ou'][0][12] != ''")
//-                   OddsItem(:odds="source.items[15].details['ou'][0]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" count=0 :details="source.items[15].details" homeAway="2")
//-                 template(v-else)
//-                   OddsDisabled
//-               .eracing-odds.flex-grow-1
//-                 template(v-if="source.items[15] && source.items[15].details['oe'] && source.items[15].details['oe'][0] && source.items[15].details['oe'][0][5] != 0 && source.items[15].details['oe'][0][5] != ''")
//-                   OddsItem(:odds="source.items[15].details['oe'][0]" idx=5 :typ="oddsType" dataType="2" label="odd")
//-                 template(v-else)
//-                   OddsDisabled
//-               .eracing-odds.flex-grow-1
//-                 template(v-if="source.items[15] && source.items[15].details['oe'] && source.items[15].details['oe'][0] && source.items[15].details['oe'][0][7] != 0 && source.items[15].details['oe'][0][7] != ''")
//-                   OddsItem(:odds="source.items[15].details['oe'][0]" idx=7 :typ="oddsType" dataType="2" label="even")
//-                 template(v-else)
//-                   OddsDisabled
//-       .d-flex
//-         .player-wrapper
//-           .marble-team.odds-group
//-             .d-flex.align-items-center.player-info-wrapper
//-               .player-name-wrapper
//-                 .player-name {{ team(source.items[12], 0, true) }}
//-             .d-flex.justify-content-center.align-items-center
//-               template(v-if="source.items[0].marketId == 3")
//-                 .eracing-odds
//-                   OddsDisabled
//-               template(v-else)
//-                 .eracing-odds
//-                   template(v-if="source.items[12].details['oxt'] && source.items[12].details['oxt'][0] && source.items[12].details['oxt'][0][5] != 0 && source.items[12].details['oxt'][0][5] != ''")
//-                     OddsItem(:odds="source.items[12].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2")
//-                   template(v-else)
//-                     OddsDisabled
//-           .odds-group
//-             .d-flex.align-items-center.player-info-wrapper.ml-1
//-               img.characters(:src="getImage(source.items[0])")
//-               .ml-2.player-name-wrapper
//-                 .player-name(v-html="team(source.items[0], 1)")
//-             .d-flex.justify-content-center.align-items-center
//-               template(v-if="source.items[0].marketId == 3")
//-                 .eracing-odds
//-                   OddsDisabled
//-               template(v-else)
//-                 .eracing-odds
//-                   template(v-if="source.items[0].details['oxt'] && source.items[0].details['oxt'][0] && source.items[0].details['oxt'][0][5] != 0 && source.items[0].details['oxt'][0][5] != ''")
//-                     OddsItem(:odds="source.items[0].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2")
//-                   template(v-else)
//-                     OddsDisabled
//-           .odds-group
//-             .d-flex.align-items-center.player-info-wrapper.ml-1
//-               img.characters(:src="getImage(source.items[3])")
//-               .ml-2.player-name-wrapper
//-                 .player-name(v-html="team(source.items[3], 1)")
//-             .d-flex.justify-content-center.align-items-center
//-               template(v-if="source.items[0].marketId == 3")
//-                 .eracing-odds
//-                   OddsDisabled
//-               template(v-else)
//-                 .eracing-odds
//-                   template(v-if="source.items[3].details['oxt'] && source.items[3].details['oxt'][0] && source.items[3].details['oxt'][0][5] != 0 && source.items[3].details['oxt'][0][5] != ''")
//-                     OddsItem(:odds="source.items[3].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2")
//-                   template(v-else)
//-                     OddsDisabled
//-           .odds-group
//-             .d-flex.align-items-center.player-info-wrapper.ml-1
//-               img.characters(:src="getImage(source.items[6])")
//-               .ml-2.player-name-wrapper
//-                 .player-name(v-html="team(source.items[6], 1)")
//-             .d-flex.justify-content-center.align-items-center
//-               template(v-if="source.items[0].marketId == 3")
//-                 .eracing-odds
//-                   OddsDisabled
//-               template(v-else)
//-                 .eracing-odds
//-                   template(v-if="source.items[6].details['oxt'] && source.items[6].details['oxt'][0] && source.items[6].details['oxt'][0][5] != 0 && source.items[6].details['oxt'][0][5] != ''")
//-                     OddsItem(:odds="source.items[6].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2")
//-                   template(v-else)
//-                     OddsDisabled
//-           .odds-group
//-             .d-flex.align-items-center.player-info-wrapper.ml-1
//-               img.characters(:src="getImage(source.items[9])")
//-               .ml-2.player-name-wrapper
//-                 .player-name(v-html="team(source.items[9], 1)")
//-             .d-flex.justify-content-center.align-items-center
//-               template(v-if="source.items[0].marketId == 3")
//-                 .eracing-odds
//-                   OddsDisabled
//-               template(v-else)
//-                 .eracing-odds
//-                   template(v-if="source.items[9].details['oxt'] && source.items[9].details['oxt'][0] && source.items[9].details['oxt'][0][5] != 0 && source.items[9].details['oxt'][0][5] != ''")
//-                     OddsItem(:odds="source.items[9].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2")
//-                   template(v-else)
//-                     OddsDisabled

//-         .player-wrapper
//-           .marble-team.odds-group
//-             .d-flex.align-items-center.player-info-wrapper
//-               .player-name-wrapper
//-                 .player-name {{ team(source.items[13], 0, true) }}
//-             .d-flex.justify-content-center.align-items-center
//-               template(v-if="source.items[0].marketId == 3")
//-                 .eracing-odds
//-                   OddsDisabled
//-               template(v-else)
//-                 .eracing-odds
//-                   template(v-if="source.items[13].details['oxt'] && source.items[13].details['oxt'][0] && source.items[13].details['oxt'][0][5] != 0 && source.items[13].details['oxt'][0][5] != ''")
//-                     OddsItem(:odds="source.items[13].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2")
//-                   template(v-else)
//-                     OddsDisabled
//-           .odds-group
//-             .d-flex.align-items-center.player-info-wrapper.ml-1
//-               img.characters(:src="getImage(source.items[1])")
//-               .ml-2.player-name-wrapper
//-                 .player-name(v-html="team(source.items[1], 1)")
//-             .d-flex.justify-content-center.align-items-center
//-               template(v-if="source.items[0].marketId == 3")
//-                 .eracing-odds
//-                   OddsDisabled
//-               template(v-else)
//-                 .eracing-odds
//-                   template(v-if="source.items[1].details['oxt'] && source.items[1].details['oxt'][0] && source.items[1].details['oxt'][0][5] != 0 && source.items[1].details['oxt'][0][5] != ''")
//-                     OddsItem(:odds="source.items[1].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2")
//-                   template(v-else)
//-                     OddsDisabled
//-           .odds-group
//-             .d-flex.align-items-center.player-info-wrapper.ml-1
//-               img.characters(:src="getImage(source.items[4])")
//-               .ml-2.player-name-wrapper
//-                 .player-name(v-html="team(source.items[4], 1)")
//-             .d-flex.justify-content-center.align-items-center
//-               template(v-if="source.items[0].marketId == 3")
//-                 .eracing-odds
//-                   OddsDisabled
//-               template(v-else)
//-                 .eracing-odds
//-                   template(v-if="source.items[4].details['oxt'] && source.items[4].details['oxt'][0] && source.items[4].details['oxt'][0][5] != 0 && source.items[4].details['oxt'][0][5] != ''")
//-                     OddsItem(:odds="source.items[4].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2")
//-                   template(v-else)
//-                     OddsDisabled
//-           .odds-group
//-             .d-flex.align-items-center.player-info-wrapper.ml-1
//-               img.characters(:src="getImage(source.items[7])")
//-               .ml-2.player-name-wrapper
//-                 .player-name(v-html="team(source.items[7], 1)")
//-             .d-flex.justify-content-center.align-items-center
//-               template(v-if="source.items[0].marketId == 3")
//-                 .eracing-odds
//-                   OddsDisabled
//-               template(v-else)
//-                 .eracing-odds
//-                   template(v-if="source.items[7].details['oxt'] && source.items[7].details['oxt'][0] && source.items[7].details['oxt'][0][5] != 0 && source.items[7].details['oxt'][0][5] != ''")
//-                     OddsItem(:odds="source.items[7].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2")
//-                   template(v-else)
//-                     OddsDisabled
//-           .odds-group
//-             .d-flex.align-items-center.player-info-wrapper.ml-1
//-               img.characters(:src="getImage(source.items[10])")
//-               .ml-2.player-name-wrapper
//-                 .player-name(v-html="team(source.items[10], 1)")
//-             .d-flex.justify-content-center.align-items-center
//-               template(v-if="source.items[0].marketId == 3")
//-                 .eracing-odds
//-                   OddsDisabled
//-               template(v-else)
//-                 .eracing-odds
//-                   template(v-if="source.items[10].details['oxt'] && source.items[10].details['oxt'][0] && source.items[10].details['oxt'][0][5] != 0 && source.items[10].details['oxt'][0][5] != ''")
//-                     OddsItem(:odds="source.items[10].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2")
//-                   template(v-else)
//-                     OddsDisabled

//-         .player-wrapper
//-           .marble-team.odds-group
//-             .d-flex.align-items-center.player-info-wrapper
//-               .player-name-wrapper
//-                 .player-name {{ team(source.items[14], 0, true) }}
//-             .d-flex.justify-content-center.align-items-center
//-               template(v-if="source.items[0].marketId == 3")
//-                 .eracing-odds
//-                   OddsDisabled
//-               template(v-else)
//-                 .eracing-odds
//-                   template(v-if="source.items[14].details['oxt'] && source.items[14].details['oxt'][0] && source.items[14].details['oxt'][0][5] != 0 && source.items[14].details['oxt'][0][5] != ''")
//-                     OddsItem(:odds="source.items[14].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2")
//-                   template(v-else)
//-                     OddsDisabled
//-           .odds-group
//-             .d-flex.align-items-center.player-info-wrapper.ml-1
//-               img.characters(:src="getImage(source.items[2])")
//-               .ml-2.player-name-wrapper
//-                 .player-name(v-html="team(source.items[2], 1)")
//-             .d-flex.justify-content-center.align-items-center
//-               template(v-if="source.items[0].marketId == 3")
//-                 .eracing-odds
//-                   OddsDisabled
//-               template(v-else)
//-                 .eracing-odds
//-                   template(v-if="source.items[2].details['oxt'] && source.items[2].details['oxt'][0] && source.items[2].details['oxt'][0][5] != 0 && source.items[2].details['oxt'][0][5] != ''")
//-                     OddsItem(:odds="source.items[2].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2")
//-                   template(v-else)
//-                     OddsDisabled
//-           .odds-group
//-             .d-flex.align-items-center.player-info-wrapper.ml-1
//-               img.characters(:src="getImage(source.items[5])")
//-               .ml-2.player-name-wrapper
//-                 .player-name(v-html="team(source.items[5], 1)")
//-             .d-flex.justify-content-center.align-items-center
//-               template(v-if="source.items[0].marketId == 3")
//-                 .eracing-odds
//-                   OddsDisabled
//-               template(v-else)
//-                 .eracing-odds
//-                   template(v-if="source.items[5].details['oxt'] && source.items[5].details['oxt'][0] && source.items[5].details['oxt'][0][5] != 0 && source.items[5].details['oxt'][0][5] != ''")
//-                     OddsItem(:odds="source.items[5].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2")
//-                   template(v-else)
//-                     OddsDisabled
//-           .odds-group
//-             .d-flex.align-items-center.player-info-wrapper.ml-1
//-               img.characters(:src="getImage(source.items[8])")
//-               .ml-2.player-name-wrapper
//-                 .player-name(v-html="team(source.items[8], 1)")
//-             .d-flex.justify-content-center.align-items-center
//-               template(v-if="source.items[0].marketId == 3")
//-                 .eracing-odds
//-                   OddsDisabled
//-               template(v-else)
//-                 .eracing-odds
//-                   template(v-if="source.items[8].details['oxt'] && source.items[8].details['oxt'][0] && source.items[8].details['oxt'][0][5] != 0 && source.items[8].details['oxt'][0][5] != ''")
//-                     OddsItem(:odds="source.items[8].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2")
//-                   template(v-else)
//-                     OddsDisabled
//-           .odds-group
//-             .d-flex.align-items-center.player-info-wrapper.ml-1
//-               img.characters(:src="getImage(source.items[11])")
//-               .ml-2.player-name-wrapper
//-                 .player-name(v-html="team(source.items[11], 1)")
//-             .d-flex.justify-content-center.align-items-center
//-               template(v-if="source.items[0].marketId == 3")
//-                 .eracing-odds
//-                   OddsDisabled
//-               template(v-else)
//-                 .eracing-odds
//-                   template(v-if="source.items[11].details['oxt'] && source.items[11].details['oxt'][0] && source.items[11].details['oxt'][0][5] != 0 && source.items[11].details['oxt'][0][5] != ''")
//-                     OddsItem(:odds="source.items[11].details['oxt'][0]" idx=5 :typ="oddsType" dataType="2")
//-                   template(v-else)
//-                     OddsDisabled

</template>

<script>
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    efTimer: () => import("@/components/mobile/efight/efTimer"),
    OddsItem: () => import("@/components/mobile/main/xitem/oddsItem"),
    OddsDisabled: () => import("@/components/mobile/main/xitem/oddsDisabled")
  },
  mixins: [mixinHDPOUOdds],
  props: {
    source: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: { 
    oddsType() {
      return this.$store.getters.pageDisplay.oddsType;
    }
   },
  methods: {
    team(player, pos, isTeam) {
      if(isTeam) {
        var n = player.homeTeam;
        return n;
      } else {
        var n = player.homeTeam.split(" - ")[pos];
        return n;
      }
    },
    getImage(x) {
      return "images/vgame/marble-survival/ball" + String(this.team(x, 0)) +".svg";
    }
  }
};
</script>